import React from "react";
import { classNames } from "./library/utils/classNames";

export const SectionBadge = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classNames(
        "inline-flex items-center gap-12 rounded-full bg-blue-200 px-12 py-8 text-16-24 font-bold text-blue-600 dark:bg-gray-800 dark:text-white",
        className
      )}
    >
      {children}
    </div>
  );
};
